import React from "react";
import { Form, ModalBuilder } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { useTranslation } from "react-i18next";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const EditReturnOnInvestment = ({
  id,
  name,
  showInCustomerView,
  disabled,
  onUpdateCustomerView,
}) => {
  const { t } = useTranslation("systemSchedule");

  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.SheetReturnOnInvestment}
      action={Actions.Edit}
    >
      <ModalBuilder
        withForm
        initialData={{
          showInCustomerView: !!showInCustomerView,
        }}
        onSubmit={(formData) => {
          onUpdateCustomerView(id, !!formData.showInCustomerView);
        }}
        renderTrigger={(showModal) => (
          <Button
            icon="pencil"
            onClick={showModal}
            className="icon-only-button"
            disabled={disabled}
            title={t("returnOnInvestmentModal.editButtonTitle", { name })}
            aria-label={t("returnOnInvestmentModal.editButtonTitle", { name })}
          />
        )}
        renderModal={(modalProps, formProps) => (
          <TranslatedModal.Edit
            {...modalProps}
            className="new-sch-item add-return-on-investment-modal"
            header={t("returnOnInvestmentModal.editTitle", { name })}
          >
            <Form {...formProps} className="highlighted-inputs">
              <div className="sheet-step">
                <div className="schedule-step">
                  <Form.Checkbox
                    field="showInCustomerView"
                    label={t(
                      "returnOnInvestmentModal.fields.customerView.label",
                    )}
                  />
                </div>
              </div>
            </Form>
          </TranslatedModal.Edit>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default EditReturnOnInvestment;
